var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12046_12077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24.9995C19.4036 24.9995 25 19.4031 25 12.4995C25 5.59595 19.4036 -0.000488281 12.5 -0.000488281C5.59644 -0.000488281 0 5.59595 0 12.4995C0 19.4031 5.59644 24.9995 12.5 24.9995Z",
    fill: "#007AB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9686 13.5055V18.659H16.9808V13.8509C16.9808 12.6437 16.5494 11.8192 15.4676 11.8192C14.642 11.8192 14.1516 12.3743 13.935 12.9117C13.8563 13.1038 13.836 13.3705 13.836 13.6399V18.6588H10.848C10.848 18.6588 10.8881 10.5155 10.848 9.67253H13.8363V10.946C13.8303 10.956 13.8218 10.9658 13.8164 10.9754H13.8363V10.946C14.2333 10.335 14.9415 9.46151 16.5291 9.46151C18.4949 9.46151 19.9686 10.7459 19.9686 13.5055ZM7.72219 5.34082C6.7001 5.34082 6.0314 6.01174 6.0314 6.89324C6.0314 7.75601 6.68071 8.44632 7.68298 8.44632H7.70236C8.74451 8.44632 9.39248 7.75601 9.39248 6.89324C9.37265 6.01174 8.74451 5.34082 7.72219 5.34082ZM6.20899 18.659H9.19595V9.67253H6.20899V18.659Z",
    fill: "#F1F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12046_12077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f8c631b7c4ae11d14a4af49a4cd03d53.svg";
export { ForwardRef as ReactComponent };